import { render, staticRenderFns } from "./ednGoto.vue?vue&type=template&id=4f67e3b1"
import script from "./ednGoto.vue?vue&type=script&lang=js"
export * from "./ednGoto.vue?vue&type=script&lang=js"
import style0 from "./ednGoto.vue?vue&type=style&index=0&id=4f67e3b1&prod&lang=scss"


/* normalize component */
import normalizer from "!./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports